export class StatisticsTableElement {
    private serie: string;
    private sqlDayMinus1: number;
    private sqlDayMinus7: number;
    private sqlMonthMinus1: number;
    private sqlYearMinus1: number;
    private sqlAverage7D: number;
    private sqlAverage30D: number;

    constructor(serie: string, sqlDayMinus1: number, sqlDayMinus7: number, sqlMonthMinus1: number, sqlYearMinus1: number, sqlAverage7D: number, sqlAverage30D: number) {
        this.serie = serie;
        this.sqlDayMinus1 = sqlDayMinus1;
        this.sqlDayMinus7 = sqlDayMinus7;
        this.sqlMonthMinus1 = sqlMonthMinus1;
        this.sqlYearMinus1 = sqlYearMinus1;
        this.sqlAverage7D = sqlAverage7D;
        this.sqlAverage30D = sqlAverage30D;
    }

    public getSerie(): string {
        return this.serie;
    }

    public getSqlDayMinus1(): number {
        return this.sqlDayMinus1;
    }

    public getSqlDayMinus7(): number {
        return this.sqlDayMinus7;
    }

    public getSqlMonthMinus1(): number {
        return this.sqlMonthMinus1;
    }

    public getSqlYearMinus1(): number {
        return this.sqlYearMinus1;
    }

    public getSqlAverage7D(): number {
        return this.sqlAverage7D;
    }

    public getSqlAverage30D(): number {
        return this.sqlAverage30D;
    }

 }